const stringSlicer = (stringValue, numberOfCharacters) => {
  const slicedString = stringValue.slice(0, numberOfCharacters);
  return `${slicedString}...`
}

export {
  stringSlicer
}